import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const GrplIndex = () => import('../views/index.vue')
const GrplProjects = () => import('../views/projects.vue')
const GrplPosts = () => import('../views/posts.vue')
const GrplPost = () => import('../views/post.vue')
const GrplPage = () => import('../views/page.vue')
const GrplLost = () => import('../views/404.vue')

const router = new Router({
    routes: [
        {
            //If none of the previous paths match then 404
            path: "/404",
            alias: "*",
            name: "404",
            component: GrplLost
        },
        {
            path: "/",
            name: "Home",
            component: GrplIndex
        },
        {
            path: "/projects/:pageSlug",
            name: "Project",
            component: GrplPage
        },
        {
            path: "/projects",
            name: "Projects",
            component: GrplProjects
        },
        {
            path: "/latest/:postSlug",
            name: "Latest Post",
            component: GrplPost
        },
        {
            path: "/latest/sound/:postSlug",
            name: "Grapple Sound",
            component: GrplPost
        },
        {
            path: "/latest/moves/:postSlug",
            name: "Grapple Moves",
            component: GrplPost
        },
        {
            path: "/latest",
            name: "Latest",
            component: GrplPosts
        },

        {
            path: "/:pageSlug",
            name: "Page",
            component: GrplPage
        },
        {
            path: "/:parentSlug/:pageSlug",
            name: "Child Page",
            component: GrplPage
        },

    ],
    mode: 'history'
});


// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
    if( to.name != '404' && store.state.show_intro === false ) {
        store.dispatch('isLoading', true);
        if ( !$('html').hasClass('activemenu') ) {
            Animations.pageOut();
        }
    }
    setTimeout(function(){
        next();
    }, 500);
});


// This callback runs before every route change, including on page load.
router.beforeResolve((to, from, next) => {
    //If navigating away from the homepage, destroy Pixi to preserve memory
    if( to.name != '404' ) {
        store.dispatch('isLoading', false);
    }
    next();
});

export default router;